import React from 'react'
import { useIntl } from 'react-intl'
import useProfileDetailTab, { collapseKey } from './useProfileDetailTab'
import CollapsePanel from 'app/componentV4/Collapses/CollapsePanel'
import GeneralInformation from './GeneralInformation'
import ContactInformation from './ContactInformation'
import AddressInformation from './AddressInformation'
import EmployerInformation from './EmployerInformation'
import SocialInformation from './SocialInformation'
import {
  generalMappingFromApi,
  contactMappingFromApi,
  addressMappingFromApi,
  employerMappingFromApi,
  socialMappingFromApi,
} from '../mapping/profileMapping'

const ProfileDetailTab = ({
  subscriber,
  subscriberId,
  languages,
  countries,
  refetchData,
}) => {
  const {
    state: { address, general, contact, employer, social },
    toggleCollapse,
  } = useProfileDetailTab()
  const { formatMessage } = useIntl()

  return (
    <div className="space-y-5">
      <CollapsePanel
        open={general}
        keys={collapseKey.general}
        title={formatMessage({ id: 'privacyPolicy.title.content1' })}
        toggleCollapse={() => toggleCollapse(collapseKey.general)}
      >
        <GeneralInformation
          initailValue={generalMappingFromApi(subscriber)}
          subscriberId={subscriberId}
          countries={countries}
          refetchData={refetchData}
        />
      </CollapsePanel>
      <CollapsePanel
        open={contact}
        keys={collapseKey.contact}
        title={formatMessage({ id: 'crm.form.contactInformation' })}
        toggleCollapse={() => toggleCollapse(collapseKey.contact)}
      >
        <ContactInformation
          initailValue={contactMappingFromApi(subscriber)}
          subscriber={subscriber}
          languages={languages}
          refetchData={refetchData}
        />
      </CollapsePanel>
      <CollapsePanel
        open={address}
        keys={collapseKey.address}
        title={formatMessage({ id: 'crm.form.addressInformation' })}
        toggleCollapse={() => toggleCollapse(collapseKey.address)}
      >
        <AddressInformation
          initailValue={addressMappingFromApi(subscriber)}
          subscriber={subscriber}
          countries={countries}
          refetchData={refetchData}
        />
      </CollapsePanel>

      <CollapsePanel
        open={employer}
        keys={collapseKey.employer}
        title={formatMessage({ id: 'crm.form.employerInformation' })}
        toggleCollapse={() => toggleCollapse(collapseKey.employer)}
      >
        <EmployerInformation
          initailValue={employerMappingFromApi(subscriber)}
          subscriberId={subscriberId}
          refetchData={refetchData}
        />
      </CollapsePanel>

      <CollapsePanel
        open={social}
        keys={collapseKey.social}
        title={formatMessage({ id: 'crm.form.socialInformation' })}
        toggleCollapse={() => toggleCollapse(collapseKey.social)}
      >
        <SocialInformation
          initailValue={socialMappingFromApi(subscriber)}
          subscriberId={subscriberId}
          refetchData={refetchData}
        />
      </CollapsePanel>
    </div>
  )
}

export default ProfileDetailTab
